import { identity, omit, pick, pickBy } from 'lodash'

export const ACCOMMODATION_FIELDS = [
  'tts',
  'stt',
  'ir',
  'preferredLanguage',
  'extraTimeOnTest',
  'stackedTranslation',
]

// Form-only field, mapped to accommodations.ttsScope.subject
export const TTS_SCOPE_SUBJECTS_FIELD = 'ttsScopeSubjects'

/**
 * Splits student form values into the `accommodations` payload and the rest.
 * - accommodation fields are kept only when truthy (existing behaviour)
 * - `ttsScopeSubjects` maps to `accommodations.ttsScope.subject` whenever the
 *   field is present on the form (an empty array resets to "all subjects");
 *   when the field is not rendered (undefined) it is left out entirely
 * - `rest` never contains accommodation fields or `ttsScopeSubjects`
 */
export const buildAccommodationsPayload = (values = {}) => {
  const accommodations = pickBy(pick(values, ACCOMMODATION_FIELDS), identity)
  const ttsScopeSubjects = values[TTS_SCOPE_SUBJECTS_FIELD]
  if (ttsScopeSubjects !== undefined) {
    accommodations.ttsScope = { subject: ttsScopeSubjects || [] }
  }
  const rest = omit(values, [...ACCOMMODATION_FIELDS, TTS_SCOPE_SUBJECTS_FIELD])
  return { accommodations, rest }
}
